import { Component } from '@angular/core';

@Component({
  selector: 'ess-column-left',
  templateUrl: './column-left.component.html',
  styleUrls: ['./column-left.component.scss'],
  standalone: false,
})
export class ColumnLeftComponent {}
